import { render } from "./FailureTable.vue?vue&type=template&id=a7ff8d5a"
import script from "./FailureTable.vue?vue&type=script&lang=js"
export * from "./FailureTable.vue?vue&type=script&lang=js"

import "./FailureTable.vue?vue&type=style&index=0&id=a7ff8d5a&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__